/**
 * Redirects migrated tenants from the legacy platform to Real Links 2.0.
 * Runs on the client for any route (including /login and Minimal layout), once company is known.
 * All users for these clients are redirected (including super admins).
 * Tenants not listed here: no redirect; behaviour unchanged from before migration redirects.
 */
export function redirectToNewPlatformIfEligible(vm) {
  if (process.env.VUE_ENV !== 'client' || typeof window === 'undefined') {
    return;
  }
  if (process.env.ADMIN_UI) {
    return;
  }

  const root = vm && vm.$root;
  if (!root) {
    return;
  }

  const go = (url) => {
    window.location.href = url;
  };

  if (root.isEXPD8) {
    go('https://default.expd8rewards.reallinks.app');
    return;
  }
  if (root.isERM) {
    go('https://default.erm.reallinks.app');
    return;
  }
  if (root.isGROWMARK) {
    go('https://default.growmark.reallinks.app');
    return;
  }
  if (root.isBT) {
    go('https://default.bt.reallinks.app');
    return;
  }
  if (root.isBerenschot) {
    go('https://default.berenschot.reallinks.app');
    return;
  }
  // if (root.isBallastNedam) {
  //   go('https://default.ballast-nedam.reallinks.app');
  //   return;
  // }
  if (root.isOptiverInterns) {
    go('https://default.optiver.reallinks.app');
    return;
  }
  if (root.isCapco) {
    go('https://default.capco.reallinks.app');
    return;
  }
  if (root.isApplusIdiada) {
    go('https://default.idiada.reallinks.app');
  }
}



// WEBPACK FOOTER //
// ./src/lib/platformMigrationRedirect.js